import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import { formatNumber } from '@client/shared/utils/jsUtils/jsUtils';
import ProgressBar from '@client/components/progressBar/ProgressBar';
import { formatPrice } from '@client/shared/utils/numberUtils/numberUtils';
import styles from './fundraiserCardTargetsBox.scss';

class FundraiserCardTargetsBox extends PureComponent {
  render() {
    const {
      largeFont,
      fullWidthProgressBar,
      targetAmount,
      amountDonated,
      className,
      showDonatedSoFarLabel,
    } = this.props;

    const target = targetAmount ? targetAmount : 0;
    const donated = amountDonated ? amountDonated : 0;

    const percent = targetAmount > 0 ? Math.round((donated * 100) / target) : 0;

    return (
      <div
        className={classNames(
          styles.fundraiserCardTargetsBox,
          fullWidthProgressBar
            ? styles.progressBarFullWidth
            : styles.progressBarNotFullWidth,
          className && className
        )}
      >
        <div
          className={
            largeFont
              ? `${styleHelper.titleMdPrimary} ${styles.text}`
              : `${styleHelper.titleSmPrimary} ${styles.text}`
          }
        >
          {showDonatedSoFarLabel && 'Insamlat hittills:'}{' '}
          {formatNumber(donated)} kronor
        </div>
        <div
          className={
            largeFont
              ? `${styles.targetProgressTextLg}`
              : `${styles.targetProgressText}`
          }
        >
          <div
            className={
              largeFont
                ? `${styleHelper.labelHeaderMd} ${styles.text}`
                : `${styleHelper.labelHeaderSm} ${styles.text}`
            }
          >
            Insamlingsmål: {formatPrice(target, 'SEK')} kr
          </div>
          <div
            className={
              largeFont
                ? `${styleHelper.labelHeaderMd} ${styles.text}`
                : `${styleHelper.labelHeaderSm} ${styles.text}`
            }
          >{`${percent}%`}</div>
        </div>
        <ProgressBar
          className={
            largeFont
              ? `${styles.progressBarPropLg}`
              : `${styles.progressBarProp}`
          }
          progress={percent}
        />
      </div>
    );
  }
}

FundraiserCardTargetsBox.propTypes = {
  className: PropTypes.string,
  largeFont: PropTypes.bool,
  percent: PropTypes.number,
  targetAmount: PropTypes.number,
  amountDonated: PropTypes.number,
  fullWidthProgressBar: PropTypes.bool,
  showDonatedSoFarLabel: PropTypes.bool,
};

export default FundraiserCardTargetsBox;
